//lib
import React, { ReactElement } from "react";

// internal-deps
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

//constants
import { DE_ICON } from "@payment-ui/constants/DeliverySla";

//styles
import S from "./DeliverySla.scss";

// test-ids
import { DELIVERY_SLA } from "@swiggy-private/payment-test-ids";

interface Props {
    deliverySla: string;
    deIcon?: string;
}

const DeliverySla = ({ deliverySla, deIcon }: Props): ReactElement => {
    const icon = deIcon ? deIcon : DE_ICON;
    return (
        <section data-testid={DELIVERY_SLA.CONTAINER} className={S.deliverySla}>
            <span className={S.deliverySlaText}>{deliverySla}</span>
            <img data-testid={DELIVERY_SLA.IMAGE} className={S.deliverySlaIcon} src={getCloudinaryUrl(icon)} />
        </section>
    );
};

export default React.memo(DeliverySla);
